import classNames from 'classnames'
import React from 'react'
import { Icon } from 'shared/ui'
import styles from './styles.module.scss'

type IFlowBranchActionProps = {
  labelX: number
  labelY: number
  onClick: React.MouseEventHandler<HTMLButtonElement>
  open: boolean
  viewOnly?: boolean
}

export const FlowBranchAction = ({
  labelX,
  labelY,
  onClick,
  open,
  viewOnly,
}: IFlowBranchActionProps) => (
  <button
    style={{
      position: 'absolute',
      transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
      pointerEvents: 'all',
    }}
    className={classNames(
      styles.action,
      { [styles.active]: open, [styles.viewOnly]: viewOnly },
      'nodrag nopan'
    )}
    onClick={onClick}
  >
    <Icon icon={'plusTrigger'} fontSize={10} />
  </button>
)
